<template>
  <v-container class="py-0">
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <v-row no-gutters>
        <v-col cols="9">
          <ValidationProvider
            id="voucher_code"
            v-slot="{ errors }"
            name="voucher_code"
            rules="required"
          >
            <v-text-field
              v-model="voucherCode"
              label="Voucher code"
              color="primary"
              :disabled="validVoucher"
              :error-messages="errors"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="3">
          <v-btn
            v-if="!validVoucher"
            class="mt-2"
            rounded
            depressed
            color="primary"
            type="submit"
            :loading="buttonLoading"
            @click="passes(applyVoucher)"
          >
            Apply
          </v-btn>
          <p v-else class="mt-4">
            <v-icon large color="primary">{{ icons.mdiCheckCircle }}</v-icon>
          </p>
        </v-col>
        <v-col cols="12">
          <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
        </v-col>
      </v-row>
    </ValidationObserver>

    <v-row v-if="validVoucher" no-gutters>
      <v-col cols="12">
        <p>
          The voucher will be used for the once-off payment of R{{
            onceOffPrice
          }}. Your credit card is being added here for future annual payments of
          R{{ subscriptionPrice }}. R1 will be deducted now, to ensure your card
          is valid, but you will be refunded for the amount.
        </p>
        <PaymentForm
          payment-plan="SUBSCRIPTION"
          :voucher-code="voucherCode"
          :tokenize-only="true"
          @payment-form-loaded="paymentFormLoaded = true"
        />

        <div v-show="!paymentFormLoaded" class="text-center">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { VERIFY_VOUCHER_QUERY } from '../../constants/graphql/vouchers';
  import PaymentForm from './PaymentForm.vue';

  export default {
    name: 'RedeemVoucherSubscription',
    components: {
      PaymentForm,
    },
    props: {
      paymentPlan: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        voucherCode: null,
        buttonLoading: false,
        errorMessage: null,
        validVoucher: false,
        paymentFormLoaded: false,
      };
    },
    computed: {
      onceOffPrice() {
        return process.env.VUE_APP_ONCE_OFF_PRICE;
      },
      subscriptionPrice() {
        return process.env.VUE_APP_SUBSCRIPTION_PRICE;
      },
    },
    watch: {
      validVoucher: function (newValue) {
        if (newValue == true) {
          this.customizePaymentFormSubmitLabel();
        }
      },
    },
    methods: {
      applyVoucher() {
        this.buttonLoading = true;
        this.$apollo
          .query({
            query: VERIFY_VOUCHER_QUERY,
            variables: {
              code: this.voucherCode,
            },
          })
          .then(response => {
            this.buttonLoading = false;
            if (response.data.verifyVoucher) {
              this.validVoucher = true;
              this.errorMessage = null;
              this.$emit('voucher-verified');
            } else {
              this.errorMessage = 'Something went wrong';
            }
          })
          .catch(error => {
            this.buttonLoading = false;
            this.errorMessage = error.message
              .replace('GraphQL error:', '')
              .trim();
          });
      },
      customizePaymentFormSubmitLabel() {
        var peachPaymentCustomization = document.createElement('script');
        peachPaymentCustomization.type = 'text/javascript';
        peachPaymentCustomization.text =
          'var wpwlOptions = {labels: {submit: "Redeem voucher"}}';
        document.body.appendChild(peachPaymentCustomization);
      },
    },
  };
</script>
